/* ==========================================================================
   CAPRIMAFFIA — MEZCLA · 1 de octubre de 2026
   JS vanilla, sin librerías. Se carga el último, con defer.

   Hace tres cosas y ninguna reimplementa lógica del tema:
     1. TALLA COMO DESPLEGABLE — envuelve el <fieldset> nativo del selector de
        variantes y le pone un botón delante. Los <input type="radio"> siguen
        siendo los del tema, así que variante, precio y compra no se tocan.
        Si este archivo no carga, el selector se ve como siempre y funciona.
     2. MENÚ EN PANEL — abre y cierra el panel a ancho completo del header,
        con teclado, Escape y velo. Solo en modo `panel` y a partir de 990 px.
     3. CONTADOR DEL CARRITO — marca el número para que el CSS le ponga
        los corchetes [ 0 ]. No cambia el valor.

   REVERTIR = quitar su línea de layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var PANEL_MIN = 990;

  /* ------------------------------------------------------------------ util */
  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ==================================================================
     1. TALLA COMO DESPLEGABLE
     ================================================================== */

  function labelOf(fieldset) {
    var legend = fieldset.querySelector('legend');
    return legend ? legend.textContent.trim() : 'Talla';
  }

  function chosenOf(fieldset) {
    var input = fieldset.querySelector('input:checked');
    if (!input) return null;
    var text = input.parentElement && input.parentElement.querySelector('.variant-option__button-label__text');
    return (text ? text.textContent : input.value || '').trim();
  }

  function paint(wrap) {
    var btn = wrap.querySelector('.cm-size__btn');
    var fieldset = wrap.querySelector('.variant-option');
    if (!btn || !fieldset) return;
    var chosen = chosenOf(fieldset);
    btn.querySelector('.cm-size__btn-text').textContent =
      chosen || ('Seleccionar ' + labelOf(fieldset).toLowerCase());
  }

  function closeAll(except) {
    each(document.querySelectorAll('.cm-size.is-open'), function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var b = w.querySelector('.cm-size__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function wrapSizes(root) {
    // Solo los selectores en modo "botones": los swatches de color se quedan
    // como están, que ahí ver el color es el 90 % de la decisión.
    each((root || document).querySelectorAll('.variant-option--buttons'), function (fieldset) {
      if (fieldset.closest('.cm-size')) return;
      if (fieldset.closest('quick-add-dialog, .cm-add, dialog')) return;  // no en tarjetas ni en el cajón

      var name = labelOf(fieldset);
      var wrap = document.createElement('div');
      wrap.className = 'cm-size';

      var label = document.createElement('span');
      label.className = 'cm-size__label';
      label.textContent = name;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-size__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-haspopup', 'listbox');
      var span = document.createElement('span');
      span.className = 'cm-size__btn-text';
      btn.appendChild(span);

      fieldset.parentNode.insertBefore(wrap, fieldset);
      wrap.appendChild(label);
      wrap.appendChild(btn);
      wrap.appendChild(fieldset);

      btn.addEventListener('click', function () {
        var open = !wrap.classList.contains('is-open');
        closeAll(wrap);
        wrap.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var checked = fieldset.querySelector('input:checked') || fieldset.querySelector('input');
          if (checked) checked.focus();
        }
      });

      // Al elegir una talla se cierra y se repinta el botón. El change lo
      // dispara el propio input nativo: el tema se entera igual que siempre.
      fieldset.addEventListener('change', function () {
        paint(wrap);
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      });

      // 🚨 Si se vuelve a elegir la talla que YA estaba puesta, el radio nativo
      // NO dispara `change` y la lista se quedaba ABIERTA TAPANDO el botón de
      // comprar: quien abría el desplegable, veía que su talla ya era la buena
      // y la volvía a tocar, se quedaba sin poder añadir al carrito hasta
      // pinchar fuera. Medido el 3 oct 2026 en la ficha nueva.
      fieldset.addEventListener('click', function (e) {
        if (!e.target.closest('label, input')) return;
        paint(wrap);
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });

      // Si la variante cambia desde fuera (galería, enlace con ?variant=),
      // el tema marca otro radio: hay que repintar el botón.
      var mo = new MutationObserver(function () { paint(wrap); });
      mo.observe(fieldset, { subtree: true, attributes: true, attributeFilter: ['checked'] });

      paint(wrap);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cm-size')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* ==================================================================
     2. MENÚ EN PANEL A ANCHO COMPLETO
     ================================================================== */

  function initPanelMenu() {
    var header = document.querySelector('.cm-header--panelmenu');
    if (!header) return;

    var scrim = document.querySelector('.cm-menu-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'cm-menu-scrim';
      document.body.appendChild(scrim);
    }

    var items = header.querySelectorAll('.cm-nav__item--has-sub');
    if (!items.length) return;

    // 🐛 Escape cerraba el panel y acto seguido devolvia el foco al enlace,
    //    cuyo `focusin` lo volvia a abrir. Mientras esta bandera esta puesta,
    //    el foco no abre nada.
    var ignoreFocus = false;

    function setOpen(item, open) {
      each(items, function (i) { if (i !== item) i.classList.remove('is-open'); });
      if (item) item.classList.toggle('is-open', open);
      var any = !!header.querySelector('.cm-nav__item--has-sub.is-open');
      document.body.classList.toggle('cm-panel-open', any);
      each(items, function (i) {
        var a = i.querySelector('.cm-nav__link');
        if (a) a.setAttribute('aria-expanded', i.classList.contains('is-open') ? 'true' : 'false');
      });
    }

    each(items, function (item) {
      var link = item.querySelector('.cm-nav__link');
      if (!link) return;
      link.setAttribute('aria-expanded', 'false');

      // En escritorio manda el hover (como la referencia). El clic en el
      // enlace padre sigue navegando: no se secuestra.
      item.addEventListener('mouseenter', function () {
        if (window.innerWidth < PANEL_MIN) return;
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        if (window.innerWidth < PANEL_MIN) return;
        setOpen(item, false);
      });
      // Con teclado: el foco dentro abre, salir cierra.
      item.addEventListener('focusin', function () {
        if (ignoreFocus) return;
        if (window.innerWidth < PANEL_MIN) return;
        setOpen(item, true);
      });
      item.addEventListener('focusout', function (e) {
        if (window.innerWidth < PANEL_MIN) return;
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });

    scrim.addEventListener('mouseenter', function () { setOpen(null, false); });
    scrim.addEventListener('click', function () { setOpen(null, false); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = header.querySelector('.cm-nav__item--has-sub.is-open');
      if (!open) return;
      var link = open.querySelector('.cm-nav__link');
      ignoreFocus = true;
      setOpen(null, false);
      if (link) link.focus();
      setTimeout(function () { ignoreFocus = false; }, 150);
    });

    // Al estrechar la ventana el panel no tiene sentido: se cierra.
    window.addEventListener('resize', function () {
      if (window.innerWidth < PANEL_MIN) setOpen(null, false);
    });
  }

  /* ==================================================================
     3. CONTADOR DEL CARRITO ENTRE CORCHETES
     ================================================================== */

  function markCartCount() {
    var scope = document.querySelector('.cm-header__col--right');
    if (!scope) return;
    each(scope.querySelectorAll('[class*="cart"] [class*="count"], [class*="cart-count"], .cart-bubble__text'), function (el) {
      if (el.closest('dialog')) return;                 // nunca dentro del cajón
      if (!/^\s*\d+\s*$/.test(el.textContent || '')) return;
      el.classList.add('cm-cart-count');
    });
  }

  /* ==================================================================
     4. EL TEMA REPINTA EL SELECTOR AL CAMBIAR DE VARIANTE
     Al elegir una talla, el tema pide la sección al servidor y sustituye el
     HTML entero del bloque: nuestro envoltorio se va con él. Un observador
     sobre la ficha lo vuelve a poner en cuanto reaparece un fieldset suelto.
     ================================================================== */

  var reWrapPending = false;

  function watchVariantPicker() {
    var host = document.querySelector('.product-information, product-information, main');
    if (!host || host.dataset.cmSizeWatch === '1') return;
    host.dataset.cmSizeWatch = '1';

    new MutationObserver(function (records) {
      var touched = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 &&
            (n.classList.contains('variant-option--buttons') ||
             (n.querySelector && n.querySelector('.variant-option--buttons')));
        });
      });
      if (!touched || reWrapPending) return;
      reWrapPending = true;
      // El tema termina de montar en el frame siguiente; si envolvemos antes,
      // nos pisa su propio render.
      requestAnimationFrame(function () {
        reWrapPending = false;
        wrapSizes(host);
      });
    }).observe(host, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------- arranque */
  function boot() {
    wrapSizes(document);
    watchVariantPicker();
    initPanelMenu();
    markCartCount();
  }

  ready(boot);

  // El editor de temas recarga secciones sueltas: hay que rehacer lo nuestro.
  document.addEventListener('shopify:section:load', function (e) {
    wrapSizes(e.target);
    watchVariantPicker();
    initPanelMenu();
    markCartCount();
  });

  // El cajón del carrito y la ficha repintan por su cuenta.
  document.addEventListener('variant:update', function () {
    each(document.querySelectorAll('.cm-size'), paint);
  });
  document.addEventListener('cart:update', markCartCount);
})();
